import _startCase from 'lodash/startCase';
import { date, EnGbLang } from 'eclipx.ui';

const STATES_MAP = {
  'New South Wales': 'NSW',
  'Victoria': 'VIC',
  'Queensland': 'QLD',
  'Tasmania': 'TAS',
  'South Australia': 'SA',
  'Western Australia': 'WA',
  'Northern Territory': 'NT',
  'Australian Capital Territory': 'ACT'
};

/**
 * Converts uppercase fields to title case
 *
 * @param value
 * @returns {*|undefined}
 */
const formatCasing = (value) => (value ? _startCase(value.toLowerCase()) : undefined);

/**
 * Converts an IDScan date to ISO format
 *
 * @param value
 * @returns {*}
 */
const formatDate = (value) => {
  if (!value) {
    return;
  }
  let parsedDate = date.extractDate(value, 'YYYY-MM-DD', EnGbLang.date);
  return date.formatDate(parsedDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ', EnGbLang.date);
};

/**
 * Return only the numbers in a string
 *
 * @param value
 * @returns {*|undefined}
 */
const extractNumbers = (value) => (value ? value.replace(/[^0-9]/g, '') : undefined);

/**
 * Remove a given list of words from a string. This will only remove full words,
 * not partial words.
 *
 * @param string The string of words to remove
 * @param words The words that will be removed
 */
const removeWords = (string = '', words) => string.replace(new RegExp(`\\b${words.join('|')}\\b`, 'gi'), '');

/**
 * Maps a GBG IDScan retrieval response to a list of useful fields.
 *
 * @param retrieval
 */
export default function (retrieval) {
  // It is assumed the primary document will be the first captured
  const primaryDocument = retrieval.ProcessedDocuments[0];
  const fields = primaryDocument.ExtractedFields.reduce((accumulator, currentValue) => {
    return {
      ...accumulator,
      [currentValue.Name]: currentValue.Value
    };
  }, {});

  const primaryAddress = fields.AddressLine2 || fields.AddressLine1 || '';
  const secondaryAddress = fields.AddressLine2 ? fields.AddressLine1 : '';

  let response = {
    firstName: formatCasing(fields.FirstName),
    middleName: formatCasing(fields.MiddleName),
    lastName: formatCasing(fields.LastName),
    dateOfBirth: formatDate(fields.BirthDate),
    streetNumber: undefined,
    address: extractNumbers(formatCasing(secondaryAddress)),
    address2: undefined,
    suburb: formatCasing(fields.AddressCity),
    state: fields.AddressState,
    postcode: fields.AddressPostCode,
    addressFull: fields.AddressFull,
    country: undefined
  };

  if (primaryDocument.DocumentCategory === 'Driving License') {
    response.licenseNumber = fields.DocumentNumber;
    response.cardNumber = fields.CardNumber;
    response.licenseIssuedState = STATES_MAP[fields.IssuingStateName];

    const splitAddress = primaryAddress.split(' ');
    response.streetNumber = splitAddress[0];
    response.address2 = removeWords(primaryAddress, [response.streetNumber, response.postcode, response.suburb, response.state]);
    response.address2 = formatCasing(response.address2.trim());
    response.licenseExpiry = formatDate(fields.ExpiryDate);
  }

  if (primaryDocument.DocumentCategory === 'Passport') {
    response.passportNumber = fields.DocumentNumber;
    response.passportIssuedBy = primaryDocument.IssuingCountryName;
  }

  return response;
}
